import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Generated class for the CustomRadioComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-radio',
  templateUrl: 'custom-radio.html'
})
export class CustomRadioComponent {

  @Input() labels: string[];
  @Input() title: string;

  @Input() inputModel: number;
  @Output() inputModelChange = new EventEmitter<number>();


  constructor() {

  }

  onChange(i: number) {
    this.inputModelChange.emit(i + 1);
  }

}



// WEBPACK FOOTER //
// ./src/components/utils/custom-radio/custom-radio.ts